import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { API_LANG_MAPPINGS } from '../../core/services/language/api-language.service';
import { FrontendLanguage, FRONTEND_LANGUAGE_LABELS } from '../../core/utils/languageUtils';
import { Language } from '../../core/api';

interface LanguageOption {
  id: FrontendLanguage;
  label: string;
}

const LANGUAGE_OPTIONS: LanguageOption[] = (Object.keys(API_LANG_MAPPINGS) as FrontendLanguage[]).map((lang) => ({
  id: lang,
  label: FRONTEND_LANGUAGE_LABELS[lang],
}));

@Component({
  standalone: false,
  selector: 'ssc-api-language-selector',
  templateUrl: './api-language-selector.component.html',
  styleUrls: ['./api-language-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class ApiLanguageSelectorComponent {
  @Output()
  public languageSelected = new EventEmitter<Language>();
  @Output()
  public cancelSelection = new EventEmitter<void>();

  public languageOptions = LANGUAGE_OPTIONS;

  public languageSelectionClicked(language: LanguageOption): void {
    this.languageSelected.emit(API_LANG_MAPPINGS[language.id] ?? Language.De);
  }
}
